import { apiPost } from "src/configs/globalFunctions";

// license_type sempre "Cloud" para acessos do portal web
const LICENSE_TYPE = "Cloud";

const getLoggedEmail = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    return user.email || "";
  } catch {
    return "";
  }
};

/**
 * Registra um acesso/ação do usuário na tabela `monitors` (fire-and-forget).
 *
 * Campos fixos:
 *  - type:          identificação da ação (ex: "AcessoRelatorio")
 *  - license_type:  sempre "Cloud"
 *  - email / razao_social / nome_fantasia: e-mail do usuário logado
 *
 * @param {string} type  Identificação da ação. Sem type, nada é enviado.
 * @param {object} [vars] Informações relevantes opcionais (var_01..var_10).
 *                        O que não for informado fica em branco.
 */
export const trackMonitor = (type, vars = {}) => {
  if (!type) return;

  const email = getLoggedEmail();

  const record = {
    type,
    license_type: LICENSE_TYPE,
    email,
    razao_social: email,
    nome_fantasia: email,
  };

  // var_01..var_10 — inclui apenas o que for informado; o resto fica em branco
  for (let i = 1; i <= 10; i += 1) {
    const key = `var_${String(i).padStart(2, "0")}`;
    const value = vars[key];
    if (value !== undefined && value !== null && value !== "") {
      record[key] = String(value);
    }
  }

  // Rota pública; o backend espera um array e cria um registro por item.
  // Fire-and-forget: erros não devem atrapalhar a navegação do usuário.
  apiPost("/monitors/create", { body: [record] }).catch(() => {});
};

export default trackMonitor;
